module.exports = __webpack_public_path__ + "static/media/terms-conditions.3519f866.png";